<template>
  <!-- 软件工单 -->
  <div>
    <div class="formA">
      <h1 style="margin-bottom:20px;text-align:center">{{$t('module.text76')}}</h1>
      <!-- 报修 -->
      <Form :model="Repair" style="width:100%" ref="orderref" :rules="orderrules">
        <FormItem :label="$t('module.text141')" :label-width="150" prop="position">
          <Input v-model="Repair.position"></Input>
        </FormItem>
        <FormItem :label="$t('module.text142')" :label-width="150" prop="urgentType">
          <Input v-model="Repair.urgentType"></Input>
        </FormItem>
        <FormItem :label="$t('golbal.text44')+':'" :label-width="150" prop="projectNam">
          <Input v-model="Repair.projectNam"></Input>
        </FormItem>
        <FormItem :label="$t('module.text268')" :label-width="150">
          <Input v-model="Repair.mark"></Input>
        </FormItem>
        <div style="text-align:center">
          <Button type="success" @click="ok5" style="width:200px" size="large">
            <span v-if="!Buttonloading5">{{$t('golbal.text13')}}</span>
            <span v-else>{{$t('golbal.text24')}}</span>
          </Button>
        </div>
      </Form>
    </div>
  </div>
  <!-- 单位查询 -->
</template>
<script>
import { addorder, searchProjects } from '../../../service/getData'
import axios from 'axios'
// import { stringify } from 'querystring';
export default {
  data() {
    return {
      // 状态
      statesAll: [
        {
          value: '1',
          name: this.$t('module.text199')
        },
        {
          value: '2',
          name: this.$t('module.text198')
        },
        {
          value: '3',
          name: this.$t('module.text138')
        }
      ],

      // 报修参数
      Repair: {
        position: '', //软件名称
        mark: '', //报修留言
        projectNam: '', //项目名称
        depId: '', //单位id
        repairOperatorId: '', //报修人id
        projectId: '0', //项目id
        typeA: '2', //1:有图片 2：没有图片
        ryType: '2', //设备工单1 软件工单2
        // urgentType: "" //紧急状态 1:最高，2中等 3一般
        urgentType: '' //版本信息
      },
      Buttonloading5: false,

      // 状态
      states: [
        {
          id: 1,
          string: this.$t('golbal.text33')
        },
        {
          id: 2,
          string: this.$t('golbal.text34')
        },
        {
          id: 3,
          string: this.$t('golbal.text35')
        }
      ],

      // 报修验证
      orderrules: {
        // sn: [{ required: true, message: this.$t('golbal.text67') +this.$t('golbal.text76'), trigger: "blur" }],
        mark: [
          { required: true, message: this.$t('golbal.text43'), trigger: 'blur' }
        ],
        urgentType: [
          {
            required: true,
            message: this.$t('golbal.text67') + this.$t('module.text142'),
            trigger: 'blur'
          }
        ],
        projectNam: [
          {
            required: true,
            message: this.$t('golbal.text67') + this.$t('module.text254'),
            trigger: 'blur'
          }
        ],
        position: [
          {
            required: true,
            message: this.$t('golbal.text67') + this.$t('module.text141'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {},
  created() {
    // 默认赋值
    this.Repair.repairOperatorId = sessionStorage.getItem('userid')
  },
  updated: function () {
    // document.getElementById('myData').scrollTop = document.getElementById('myData').scrollHeight;
  },
  methods: {
    // 报修提交
    ok5() {
      this.Buttonloading5 = true
      this.$refs.orderref.validate((valid) => {
        if (valid) {
          addorder(this.Repair).then((res) => {
            if (res.data.code == 200) {
              this.Buttonloading5 = false
              this.$Message.destroy()
              this.$Message.success(this.$t('golbal.text42'))
              // 重置
              this.$refs.orderref.resetFields()
            } else {
              this.Buttonloading5 = false
              this.$Message.destroy()
              this.$Message.error(res.data.msg)
              // 重置
              this.$refs.orderref.resetFields()
            }
          })
        } else {
          this.Buttonloading5 = false
          this.$Message.error(this.$t('golbal.text18'))
        }
      })
    }
  },
  mounted() {}
}
</script>
<style  scoped>
.formA {
  width: 40%;
  margin: 0 auto;
}
</style>
